<template>
  <v-card :min-width="minWidth" :flat="!small" :class="{ 'my-5': small }" light>
    <v-toolbar flat height="10px" :color="appointmentColor" dark />
    <v-card-text :class="{ 'pt-0': small }">
      <v-toolbar flat>
        <v-toolbar-title class="Appointment-title" :class="{ 'Appointment-title--primary': small }">{{
          selectedAppointment.service.serviceType != 'custom'
            ? (selectedAppointment.name || $t(`services.${this.selectedAppointment.service.serviceType}`)) 
            : selectedAppointment.service.name
        }}</v-toolbar-title>
        <v-spacer />
        <div class="AppointmentCard-actions">
          <v-btn @click="confirmCancel" icon v-if="selectedStatus !== appointmentStatus.CANCELED">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <router-link :to="{ name: 'EditAppointment', params: { appointmentId: selectedAppointment.appointmentId } }" v-if="selectedStatus !== appointmentStatus.CANCELED">
            <v-btn @click="sendGtmEditAppointment" icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </router-link>
          <v-btn v-if="!small" @click="close" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <div v-else>
            <div class="Appointment-time">
              <span class="mr-5">{{ appointmentDate }}</span>
              <span>{{ intervalHours }}</span>
              <v-spacer />
            </div>
          </div>
        </div>
      </v-toolbar>
      <div v-if="!small" class="Appointment-time">
        <span>{{ appointmentDate }}</span>
        <v-spacer />
        <span>{{ intervalHours }}</span>
        <v-spacer />
      </div>
    </v-card-text>
    <v-divider v-if="!small" />
    <v-card-text>
      <ul v-if="!isConfirmation" class="Appointment-list">
        <li v-for="(info, i) in eventInfos" :key="i">
          <span class="AppointmentCard-label">{{ info.title }}</span> : {{ info.value }}
        </li>
        <li v-if="selectedAppointment.comment">
          <div class="AppointmentCard-label mt-9">{{ $t('appointmentCard.commentLabel') }}</div>
          <div>{{ selectedAppointment.comment }}</div>
        </li>
      </ul>
      <div v-else class="d-flex justify-center align-center mt-12 mb-4">
        <div class="px-5 text-center">
          <v-icon large>mdi-delete</v-icon>
          <div class="mt-4 font-weight-bold">{{ $t('appointmentCard.cancelConfirmationMessage') }}</div>
        </div>
      </div>
    </v-card-text>
    <v-divider v-if="!small" class="my-3" />
    <v-card-actions class="Appointment-actions">
      <template v-if="!isConfirmation">
        <AddToCalendarMenu :appointment="selectedAppointment">
          <template v-slot:default="{ on }">
            <v-btn v-if="!small" v-on="on" text color="text lighten-1">
              {{ $t('calendar.addToCalendar') }}
            </v-btn>
          </template>
        </AddToCalendarMenu>
        <v-spacer />
        <!-- <v-select
          v-if="selectedStatus !== appointmentStatus.CANCELED"
          class="AppointmentCard-actions-select"
          :items="appointmentStatusItems"
          item-text="label"
          item-value="value"
          :value="selectedStatus"
          @input="handleStatusChange"
          color="secondary"
          dense
        /> -->
      </template>
      <template v-else>
        <v-btn @click="isConfirmation = false" class="text-none" depressed text>{{
          $t('appointmentCard.cancelCancelButton')
        }}</v-btn>
        <v-spacer />
        <v-btn @click="cancel" class="text-none" color="primary" depressed text>{{
          $t('appointmentCard.confirmCancelButton')
        }}</v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import AddToCalendarMenu from '@/components/lib/AddToCalendarMenu'
import * as CONST from '@/const/shared'
import gql from 'graphql-tag'

const UPDATE_APPOINTMENT = gql`
  mutation updateAppointment(
    $appointmentId: CustomId!
    $serviceUuid: GUID!
    $appointmentInput: UpdateAppointmentInput!
  ) {
    updateAppointment(appointmentId: $appointmentId, appointmentInput: $appointmentInput, serviceUuid: $serviceUuid) {
      appointmentId
      status
    }
  }
`

export default {
  components: { AddToCalendarMenu },
  props: {
    cancelConfirmation: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '450px'
    },
    options: {
      type: Array,
      default: () => [],
      validator: value => {
        return value.every(el => typeof el === 'string')
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    selectedAppointment: {
      type: Object,
      default: Object // add validation
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      appointmentStatus: CONST.appointmentStatus,
      selectedStatus: this.selectedAppointment.status,
      isConfirmation: false
    }
  },

  computed: {
    appointmentColor() {
      return this.selectedAppointment.service.serviceType != 'custom'
        ? this.selectedAppointment.service.serviceType
        : this.selectedAppointment.service.color
    },
    appointmentDate() {
      const upperFirstChar = string => string[0].toUpperCase() + string.slice(1)
      const options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
      }
      const newDate = new Date(this.selectedAppointment.start)

      return upperFirstChar(newDate.toLocaleString(this.$route.params.lang, options))
    },
    appointmentStatusItems() {
      let appointmentStatus = JSON.parse(JSON.stringify(this.appointmentStatus))
      delete appointmentStatus.CANCELED
      delete appointmentStatus.COMPLETED
      return Object.values(appointmentStatus).map(status => ({
        label: this.$t(`appointmentCard.appointmentStatus.${status}`),
        value: status
      }))
    },
    eventInfos() {
      const infos = {
        type: {
          title: 'type',
          value: this.selectedAppointment.type
        },
        customerFullName: {
          title: this.$t('createAppointmentPage.form.lastname'),
          value: this.selectedAppointment.customerFullName
        },
        customerPhoneNumber: {
          title: this.$t('createAppointmentPage.form.phone'),
          value: this.selectedAppointment.customerPhoneNumber
        },
        customerEmail: {
          title: this.$t('createAppointmentPage.form.email'),
          value: this.selectedAppointment.customerEmail
        },
        for: {
          title: 'for',
          value: this.selectedAppointment.for
        },
        age: {
          title: this.$t('createAppointmentPage.form.age'),
          value: this.$t(`calendar.appointment.${this.selectedAppointment.age}`)
        }
      }

      return this.options.length
        ? this.options.map(option => infos[option]).filter(el => !!el.value)
        : Object.values(infos).filter(el => !!el.value)
    },
    intervalHours() {
      const options = {
        hour: 'numeric',
        minute: 'numeric'
      }
      const locale = this.$route.params.lang
      const start = new Date(this.selectedAppointment.start)
      const end = new Date(this.selectedAppointment.end)

      return start.toLocaleString(locale, options) + ' - ' + end.toLocaleString(locale, options)
    }
  },

  methods: {
    cancel() {
      this.$emit('cancel', this.selectedAppointment.appointmentId)
      this.isConfirmation = false
    },
    confirmCancel() {
      if (!this.cancelConfirmation) {
        this.cancel()
      } else {
        this.isConfirmation = true
      }
    },
    close() {
      this.$emit('close')
    },
    async handleStatusChange(value) {
      const appointmentInput = {
        status: value
      }

      const response = await this.$apollo.mutate({
        mutation: UPDATE_APPOINTMENT,
        variables: {
          appointmentId: this.selectedAppointment.appointmentId,
          serviceUuid: this.selectedAppointment.serviceUuid,
          appointmentInput
        }
      })
      this.$emit('changeStatus', response?.data?.updateAppointment)
      this.selectedStatus = response?.data?.updateAppointment?.status
    },
    sendGtmEditAppointment() {
      this.$gtm.trackEvent({
        event: 'appointment_edition',
        practitioner_id: this.$store.state.myUser.ecpId,
        shopUuid: this.$store.state.currentShopUuid
      })
    }
  },

  watch: {
    selectedAppointment(value) {
      this.selectedStatus = value.status
    }
  }
}
</script>

<style scoped lang="scss">
.AppointmentCard-label {
  text-transform: capitalize;
  font-size: 1.2em;
  font-weight: bold;
}

.Appointment-list {
  list-style: none;
}

.Appointment-list li {
  margin: 15px 0;
  color: var(--v-text-lighten1);
}

.Appointment-title--primary {
  color: var(--v-primary-base);
}

.Appointment-time {
  padding: 0 16px;
  display: flex;
}

.Appointment-actions {
  padding: 0 15px 15px;
}

.AppointmentCard-actions {
  display: flex;
  min-width: 150px;
  justify-content: end;
}
.AppointmentCard-actions-select {
  width: 20%;
}
a {
  text-decoration: none;
}
</style>

<style lang="scss">
.App-galileo .Appointment-title--primary {
  color: var(--v-primaryAccent-base);
}
</style>
